module.exports = __webpack_public_path__ + "static/media/SDFSA_6-682w.a7a6e2c5.webp";